/**
 *
 * @param object Transform object to a request parameter string
 */
function transformRequestParams(object) {
    if (object) {
        return ('?' +
            Object.keys(object)
                .map(function (key) { return key + '=' + object[key]; })
                .join('&'));
    }
    return '';
}
/**
 * Before doing changes in here please see the DOC in README.md. If you made changes please keep the doc up2date!!!
 *
 * @param key - main identifier e.g. the web application name
 * @param id - secondary identifier e.g. the module name
 * @param elem - the element short descriptive name e.g. play_button, terms_link...
 * @param action - if elem has special action
 * @param data - use this to pass any additional data
 */
export default function track(options, config) {
    var contextPath = config && config.stealthy === true ? '/gd/schellfisch' : '/gd/tracking';
    if (!options.key) {
        return new Promise(function () {
            throw 'INVALID TRACKING CALL - required property key is missing!';
        });
    }
    // TODO remove warnings if we have refactored tournaments-web, shop-web, shop-settings, shop-express
    // type (enum TYPE) and userType are not required to track anymore
    if (options.type || options.userType) {
        console.warn("deprecated tracking property ".concat(options.type ? '"type"' : '', " ").concat(options.userType ? '"userType"' : '', " detected"));
    }
    if (!options.id) {
        options.id = options.key;
    }
    if (config && config.beacon === true) {
        var succeeded = navigator.sendBeacon(contextPath + transformRequestParams(options));
        return Promise.resolve(succeeded);
    }
    else {
        return fetch(contextPath + transformRequestParams(options), {
            credentials: 'same-origin',
        });
    }
}
//# sourceMappingURL=track.js.map